import React from 'react';

const launchpadGlassCardStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    backdropFilter: 'blur(64px) saturate(200%)',
    WebkitBackdropFilter: 'blur(64px) saturate(200%)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -1px 0 rgba(255, 255, 255, 0.04), 0 30px 86px rgba(0, 0, 0, 0.44)',
};

const StatCard = ({ label, value, subtext, trend }) => {
    return (
        <div className="overview-launchpad-card relative group overflow-hidden rounded-2xl p-5 transition-all duration-300 hover:-translate-y-1" style={launchpadGlassCardStyle}>
            <div className="relative z-10 flex flex-col h-full justify-between items-center text-center">
                <div className="flex justify-center items-center w-full mb-2 relative">
                    <span className="text-xs font-semibold uppercase" style={{ color: 'rgba(255, 255, 255, 0.5)', letterSpacing: '0.1em' }}>{label}</span>
                    {trend && (
                        <span className={`absolute right-0 top-0 text-[10px] font-mono px-1.5 py-0.5 rounded border ${trend === 'up' ? 'border-green-500/30 bg-green-500/10 text-green-400' : 'border-neutral-500/30 bg-neutral-500/10 text-neutral-400'}`}>
                            {trend === 'up' ? '▲' : '▼'}
                        </span>
                    )}
                </div>

                <div className="flex items-baseline justify-center gap-2 mt-1">
                    <span className="text-3xl font-semibold text-[#FFFFFF] tracking-tighter">
                        {value}
                    </span>
                    {subtext && <span className="text-xs text-gray-500 font-medium">{subtext}</span>}
                </div>
            </div>
        </div>
    );
};

const StatsRow = ({ stats }) => {
    // Default dummy data if not provided (for dev/preview)
    const data = {
        totalIssues: stats?.totalIssues || 12,
        critical: stats?.critical || 3,
        sites: stats?.sites || 142,
        licensedUsers: stats?.licensedUsers ?? '—',
        paidSeats: stats?.paidSeats ?? null,
        uptime: stats?.uptime || '99.9%'
    };

    const licensedSubtext = data.paidSeats ? `of ${data.paidSeats} Paid Seats` : 'M365 Tenant';

    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full mb-6 animate-fadeInUp">
            <StatCard label="Active Issues" value={data.totalIssues} color="blue" />
            <StatCard label="Critical Alerts" value={data.critical} color="red" />
            <StatCard label="Licensed Users" value={data.licensedUsers} subtext={licensedSubtext} color="purple" />
        </div>
    );
};

export default StatsRow;
